import React from 'react';
import './FactionOrcsDescription.css';
import DescriptionValueWithIcon from "../../../PolicyCardOverlay/DescriptionValueWithIcon/DescriptionValueWithIcon";

const FactionOrcsDescription = () => {

  const unit = <img
    className={'policy-description-icon-unit policy-description-icon-unit-margin-right'}
    src={'/img/icons/unit d6 friend.png'}
    alt={'Отряд'}
    title={'Отряд'}
  />

  const size = <img
    className="faction-description-icon" src="/img/icons/unit size.png" alt="Размер отряда" title="Размер отряда"
  />;

  const damageMarginRightLeft = <img
    className="faction-description-icon faction-description-icon-margin-right-left" src="/img/icons/damage.png"
    alt="Урон" title="Урон"
  />;

  const damage = <img className="faction-description-icon" src="/img/icons/damage.png" alt="Урон" title="Урон"/>;

  const size2ValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-right-left'}
    value={2}
    icon={size}
  />
  const size1ValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-right-left'}
    value={1}
    icon={size}
  />
  const size0ValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-right-left'}
    value={0}
    icon={size}
  />


  const damage3ValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-left-end text-war'}
    value={3}
    icon={damage}
  />
  const damage2ValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-left-end text-war'}
    value={2}
    icon={damage}
  />
  const damage1ValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-left-end text-war'}
    value={1}
    icon={damage}
  />

  return (
    <>
      <div className="policy-description_line">
        {unit} при получении {damageMarginRightLeft} теряет:
      </div>
      <div className="policy-description_line policy-description_line-margin-top">
        • {size2ValueAndIcon} за {damage3ValueAndIcon},
      </div>
      <div className="policy-description_line">
        • {size1ValueAndIcon} за {damage2ValueAndIcon},
      </div>
      <div className="policy-description_line">
        • {size0ValueAndIcon} за {damage1ValueAndIcon}.
      </div>
    </>
  );
};

export default FactionOrcsDescription;
